import React, { useEffect, useRef, useState } from "react";
import NoDataFound from "../../Extra/NoDataFound";
import axios from "axios";
// import { DownloadExcel } from "../../Utilitie";

const tableHead = [
  "Sr No.",
  "Date",
  "item_name",
  "requested_qty",
  "remarks",
  "status",
  "document",
];

const ROWS_PER_PAGE = 10;

const DemandTable = ({ data }) => {
  /////////////////////////////////////////////////

  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [currentPage, setCurrentPage] = useState(1);
  const [id, setId] = useState(null);
  const [pdfData, setPdfData] = useState([]);
  const [showAttachments, setShowAttachments] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  /////////////////////////////////////////////////

  const btnStyle = (active, color) => ({
    background: active ? color : "#e9ecef",
    color: active ? "#fff" : "#adb5bd",
    border: "none",
    borderRadius: "10px",
    transition: "all .2s ease",
  });

  //////////////////////////////////////////////////

  const totalPages = Math.ceil(data.length / ROWS_PER_PAGE);
  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const paginatedData = [...(data || [])]
    .sort((a, b) => new Date(b.requested_date) - new Date(a.requested_date))
    .slice(startIndex, startIndex + ROWS_PER_PAGE);

  /////////////////////////////////////////////////////

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}store/demands/${id}/pdf_details`,
      );
      if (response.data.status === "ok") {
        setPdfData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);
  //////////////////////////////////////////////////

  return (
    <div className="mt-3">
      <div
        style={{
          maxHeight: "800px",
          overflow: "auto",
          border: "8px solid #e1dde9",
        }}
        className="  shadow  rounded "
      >
        <div
          className=" p-2 m-0 text-white  d-flex justify-content-between"
          style={{ background: "#5c5666" }}
        >
          <span
            className="btn btn-sm m-1 pt-2 fs-5 fw-semibold shadow-sm text-white rounded-3"
            style={{ background: "linear-gradient(135deg,#e85d04,#f48c06)" }}
          >
            Demand Report
          </span>
          {data.length > ROWS_PER_PAGE && (
            <div className="d-flex align-items-center justify-content-center gap-2 p-2">
              <button
                className="btn btn-sm px-3 fw-semibold shadow-sm"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
                style={btnStyle(
                  currentPage !== 1,
                  "linear-gradient(135deg,#6f42c1,#8e5de7)",
                )}
              >
                ← Previous
              </button>

              <span
                className="px-3 py-2 fw-bold shadow-sm"
                style={{
                  background: "linear-gradient(135deg,#f8f9fa,#e9ecef)",
                  color: "#4a3f55",
                  borderRadius: "10px",
                  border: "1px solid #dee2e6",
                  minWidth: "120px",
                  textAlign: "center",
                }}
              >
                Page <span className="text-primary">{currentPage}</span> of{" "}
                <span style={{ color: "#e85d04" }}>{totalPages}</span>
              </span>

              <button
                className="btn btn-sm px-3 fw-semibold shadow-sm"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
                style={btnStyle(
                  currentPage !== totalPages,
                  "linear-gradient(135deg,#e85d04,#f48c06)",
                )}
              >
                Next →
              </button>
            </div>
          )}
        </div>
        <div className="responsive-table ">
          <table className="table table-hover align-middle m-0">
            <thead>
              <tr>
                {tableHead.map((head, i) => (
                  <th
                    key={i}
                    className="p-3 text-center"
                    style={{
                      whiteSpace: "nowrap",
                      border: "none",
                    }}
                  >
                    {head.toUpperCase().replace(/_/g, " ")}
                  </th>
                ))}
              </tr>
            </thead>

            {data.length > 0 && (
              <tbody>
                {paginatedData.map((Obj, index) => {
                  const statusStyle = {
                    COMPLETED: {
                      background: "#d1f7c4",
                      color: "#176b2c",
                      icon: "✓",
                    },
                    PENDING: {
                      background: "#fff3cd",
                      color: "#856404",
                      icon: "⏳",
                    },
                    APPROVED: {
                      background: "#cfe2ff",
                      color: "#084298",
                      icon: "✓",
                    },
                    PARTIALLY_ISSUED: {
                      background: "#ffe0b2",
                      color: "#8a4b08",
                      icon: "⚠",
                    },
                    REJECTED: {
                      background: "#f8d7da",
                      color: "#842029",
                      icon: "✕",
                    },
                  };

                  const status = statusStyle[Obj.status] || {
                    background: "#eee",
                    color: "#333",
                    icon: "",
                  };

                  return (
                    <tr key={index}>
                      <td className="text-center fw-bold pt-2">
                        {startIndex + index + 1}
                      </td>

                      <td className="text-center fw-bold">
                        {Obj.requested_date?.slice(0, 10)}
                      </td>

                      <td className="text-center fw-bold">{Obj.item_name}</td>

                      <td className="text-center fw-bold">
                        {Obj.requested_qty}
                      </td>

                      <td className="text-center fw-bold"> {Obj.remarks}</td>

                      <td className="text-center">
                        <span
                          className="px-3 py-2 rounded-pill fw-bold"
                          style={{
                            background: status.background,
                            color: status.color,
                          }}
                        >
                          {status.icon} {Obj.status}
                        </span>
                      </td>

                      <td style={{ width: "400px" }}>
                        {" "}
                        <div className="d-flex align-items-center">
                          {" "}
                          <button
                            className="btn btn-sm px-3 fw-semibold text-white shadow-sm rounded-pill"
                            onClick={() => setId(id === Obj.id ? null : Obj.id)}
                            style={{
                              background:
                                "linear-gradient(135deg,#e85d04,#f48c06)",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {" "}
                            Show Attachments →{" "}
                          </button>{" "}
                          <div
                            className={`collapse ${id === Obj.id ? "show" : ""}`}
                          >
                            <div className="d-flex align-items-center gap-2 ms-2">
                              {" "}
                              {pdfData
                                ?.filter((item) => item.demand_id === id)
                                .map((item) => (
                                  <button
                                    key={item.attachment_id}
                                    className="btn btn-sm px-3 fw-semibold text-white shadow-sm rounded-pill"
                                    style={{
                                      background:
                                        "linear-gradient(135deg,#6f42c1,#8e5de7)",
                                      whiteSpace: "nowrap",
                                    }}
                                    onClick={() =>
                                      window.open(item.download_url, "_blank")
                                    }
                                  >
                                    {" "}
                                    {item.attachment_type}{" "}
                                  </button>
                                ))}{" "}
                            </div>{" "}
                          </div>{" "}
                        </div>{" "}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            )}
          </table>

          {data?.length === 0 && <NoDataFound />}
        </div>
      </div>
    </div>
  );
};

export default DemandTable;
